import { Clock, Gauge, RefreshCw } from "lucide-react";
import { RISK_PROFILES } from "../lib/portfolioMeta";

function Fact({ icon: Icon, label, children }) {
  return (
    <div className="flex gap-3 py-3 border-t border-white/5 first:border-0 first:pt-0">
      <span className="text-zinc-500 mt-0.5">
        <Icon className="w-4 h-4" />
      </span>
      <div>
        <div className="text-[10px] uppercase tracking-[0.18em] text-zinc-500">{label}</div>
        {children}
      </div>
    </div>
  );
}

/**
 * Section « La stratégie » de la page détail (visible par tous, même portefeuille verrouillé).
 * Champs remplis dans l'éditeur admin : strategy_text, horizon, risk_profile, rebalancing.
 * Ne s'affiche pas si tout est vide.
 */
export default function PortfolioStrategy({ text, horizon, riskProfile, rebalancing }) {
  const riskIndex = RISK_PROFILES.findIndex((r) => r.id === riskProfile);
  const hasFacts = horizon || riskIndex >= 0 || rebalancing;
  if (!text && !hasFacts) return null;

  const gaugeColor = riskIndex >= 3 ? "bg-orange-400" : riskIndex === 2 ? "bg-orange-300" : "bg-emerald-400";

  return (
    <div
      className={`rounded-xl border border-white/5 bg-card p-6 grid gap-8 ${text && hasFacts ? "md:grid-cols-[1.5fr_1fr]" : ""}`}
      data-testid="sideb-strategy"
    >
      {text && (
        <div>
          <h2 className="font-display font-bold text-lg mb-3">La stratégie</h2>
          <p className="text-zinc-300 leading-relaxed whitespace-pre-line">{text}</p>
        </div>
      )}
      {hasFacts && (
        <div className={text ? "md:border-l md:border-white/5 md:pl-8" : ""}>
          {!text && <h2 className="font-display font-bold text-lg mb-4">La stratégie</h2>}
          {horizon && (
            <Fact icon={Clock} label="Horizon conseillé">
              <div className="mt-0.5 text-sm text-zinc-100">{horizon}</div>
            </Fact>
          )}
          {riskIndex >= 0 && (
            <Fact icon={Gauge} label="Profil de risque">
              <div className="mt-0.5 text-sm text-zinc-100">{RISK_PROFILES[riskIndex].label}</div>
              <div className="flex gap-1 mt-1.5" aria-hidden="true">
                {RISK_PROFILES.map((r, i) => (
                  <span key={r.id} className={`h-1.5 w-8 rounded-full ${i <= riskIndex ? gaugeColor : "bg-white/10"}`} />
                ))}
              </div>
            </Fact>
          )}
          {rebalancing && (
            <Fact icon={RefreshCw} label="Rééquilibrage">
              <div className="mt-0.5 text-sm text-zinc-100">{rebalancing}</div>
            </Fact>
          )}
        </div>
      )}
    </div>
  );
}
